<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="applyDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="500px"
            center>
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">修改手机号码</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <el-form class="form" :model="ruleForm" :rules="rules" ref="ruleForm" labelWidth="auto">
                <el-form-item prop="phone" label="手机号">
                    <el-input v-model="ruleForm.phone" maxlength="11" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item prop="code" label="验证码">
                    <div class="login-input">
                        <el-input v-model="ruleForm.code" maxlength="6" placeholder="请输入验证码"></el-input>
                        <div class="code-text" @click="submitSMS">
                            {{codeText}} <span v-if="typeof codeText === 'number'">秒后重新发送</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate black" @click="cancel">取消</el-button>
                <el-button class="operate" :loading="loading" @click="submitForm('ruleForm')">
                    修改
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import rules from '@/utils/rules'
    import {sendForgetSms} from "@/api/login";
    import {setPhone} from '@/api/member'

    export default {
        name: "noticeDetailDialog",
        props: {
            applyDialogVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: false,
                ruleForm: {
                    phone: '',
                    code: '',
                },
                rules: {
                    phone: rules.tel,
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'change'}
                    ],
                },
                codeText: '获取验证码', // 验证码文字
                id: null, // 计时器id
                timeId: null, // 一次性计时器id
                code_sign: '',
            }
        },
        created() {
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.setPhone();
                    }
                });
            },
            async setPhone() {
                this.loading = true
                let _data = await setPhone(this.user.phone, this.ruleForm.phone, this.ruleForm.code)
                this.loading = false
                if (_data.status === 200) {
                    this.$message.success(_data.msg)
                    this.$store.state.user.phone = this.ruleForm.phone
                    this.$store.dispatch('setUserInfo', this.$store.state.user).then(() => {
                    })
                    this.$emit('watchState', true)
                }
            },
            cancel() {
                this.$emit('watchState', false)
            },
            submitSMS() {
                this.$refs.ruleForm.validateField('phone', (valid) => {
                    if (!valid) {
                        this.sendCode()
                    }
                })
            },
            async sendCode() {
                if (this.codeText === '获取验证码' || this.codeText === '重新发送') {
                    const loading = this.$loading({
                        lock: true,
                        text: '正在发送...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let _data = await sendForgetSms(this.ruleForm.phone, 2)
                    loading.close();
                    if (_data.status === 200) {
                        this.code_sign = _data.data
                        let codeNum = 60
                        this.id = setInterval(() => {
                            if (codeNum === 0) {
                                this.codeText = '重新发送'
                                clearInterval(this.id)
                                return
                            }
                            if (typeof codeNum === 'number') {
                                codeNum--
                                this.codeText = codeNum
                            }
                        }, 1000)
                    } else {
                        this.codeText = '重新发送'
                        clearInterval(this.id)
                    }
                }
            },
        },
        watch: {}
    }
</script>

<style scoped lang="scss">

    .detail-dialog-container {
        .dialog-container {
            .dialog-header {
                height: 55px;
                .dialog-title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .dialog-close {
                    font-size: 21px;
                    color: #0a2240;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .login-input {
                position: relative;
                .code-text {
                    position: absolute;
                    right: 12px;
                    top:50%;
                    transform: translateY(-50%);
                    color: #0a2240;
                    cursor: pointer;
                }
            }
            .dialog-operate {
                margin-top: 20px;
                .operate {
                    width: 200px;
                    height: 40px;
                    border-radius: 20px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    &.black {
                        background: #0a2240 none;
                    }
                }
                .operate + .operate {
                    margin-left: 80px;
                }
            }
            .dialog-footer {
                height: 40px;
                background-color: #e7eff9;
                padding: 0 20px;
                border-radius: 0 0 10px 10px;
                .content {
                    font-size: 16px;
                    color: #8b9fbe;
                }
            }
        }
    }
</style>